import { render, staticRenderFns } from "./pacchettiCategorie.vue?vue&type=template&id=45089d25&"
import script from "./pacchettiCategorie.vue.ts?vue&type=script&lang=ts&"
export * from "./pacchettiCategorie.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports